module.exports = __webpack_public_path__ + "static/img/34.429f8f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/34.png
// module id = hVQO
// module chunks = 0